<!-- 
<div class="modal-content">
    <div class="modal-header">
    <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="modal-body">
      <div class="card">
          <div class="card-header card-header-icon card-header-rose">

            <h4 class="card-title text-center font-weight-bold">Change Password</h4>
          </div>
          <div class="card-body">
            <form>
                <mat-form-field>
                  <mat-label>New Password</mat-label>
                  <input matInput type="password"  [(ngModel)]="password1" required>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>Confirm Password</mat-label>
                  <input matInput type="password"  [(ngModel)]="password2" required>
                </mat-form-field>
              </form>
            
            <button class="gts-btn-primary" mat-button (click)="onSubmit()">Change Password</button>
<div mat-dialog-content>

     


              
     
              </div>

              
    
          
             
              <div class="row">
                
               
                
              </div>
         
                
  </div>
      </div>
  </div>
</div>
</div> -->

 


<div class="main-content">
  <div class="pr-2">
    <button (click)="cerrar();" type="button" class="close pt-2 z-3" style="position: relative;" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
    <div class="d-flex justify-content-center">
    <h2 mat-dialog-title>Change Password</h2>
    </div>
  <mat-dialog-content>
    <form>
      <mat-form-field>
        <mat-label>New Password</mat-label>
        <input matInput type="password"  [(ngModel)]="password1" [type]="hide ? 'password' : 'text'" required>
        <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password"  [(ngModel)]="password2" [type]="hide1 ? 'password' : 'text'"  required>
        <mat-icon matSuffix (click)="hide1 = !hide1">{{hide1 ? 'visibility_off' : 'visibility'}}</mat-icon>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>

  </mat-dialog-actions>
  <div class="d-flex justify-content-end pb-2 pr-2">
    <button class="gts-btn-primary" matRipple (click)="onSubmit()">Change Password</button>
    </div>
</div>